import * as React from 'react'
import { Helmet } from 'react-helmet'
import { withRouter } from 'react-router'
import qs from 'qs'

// components
import CatalogLayout from '../../../../components/ui/CatalogLayout/CatalogLayout'
import OffersModal from '../../../../components/home/OffersModal/OffersModal'
import {
  BannerContent,
  Heading,
  BannerDescription,
  RewardsCatalogDescription,
  RewardsCatalogTitle,
  StyledBanner,
  StyledCatalogCard,
  StyledCatalogList,
  StyledTextInput,
  StyledZingLogo,
} from './MainView.style'

// data
import filterString from '../../../../services/data/filterString'
import { REWARDS_OFFERS_CATALOG } from '../../../../services/data/errorNames.json'

// analytics
import {
  setGAPageView,
  setGAEvent,
} from '../../../../services/analytics/google-analytics'

// controllers
import {
  doActivateOffer,
  doGetOffer,
  doGetAllOffers,
} from '../../../../controllers/Offers'

class MainView extends React.Component {
  constructor(props) {
    super(props)

    const { location } = props.history

    const initialSearch = qs.parse(location.search, {
      ignoreQueryPrefix: true,
    })

    this.state = {
      offers: [],
      searchQuery: initialSearch.q || '',
      searched: [],
    }

    this.getRewardsOffers(initialSearch.catalogId || 0)
  }

  componentWillMount() {
    this.retrieveInitialData()
  }

  componentDidMount() {
    const { location } = this.props
    setGAPageView(location.pathname)
  }

  componentDidUpdate(prevProps) {
    const { match, location } = this.props
    const { viewType, viewId } = match.params
    const {
      viewType: prevViewType,
      viewId: prevViewId,
    } = prevProps.match.params

    if (viewType !== prevViewType || viewId !== prevViewId) {
      this.displayModal()
    }

    if (location.pathname !== prevProps.location.pathname) {
      setGAPageView(location.pathname)
    }
  }

  getRewardsOffers = async () => {
    const {
      accessToken,
      history,
      errorList,
      setError,
      removeError,
    } = this.props

    if (errorList.length) {
      removeError(REWARDS_OFFERS_CATALOG)
    }

    const search = qs.parse(history.location.search, {
      ignoreQueryPrefix: true,
    })

    const pageLoadStart = Date.now()
    await doGetAllOffers({
      accessToken,
      onSuccess: ({ data }) => {
        this.setState({
          offers: data.sort((a, b) =>
            a.title > b.title ? 1 : a.title < b.title ? -1 : 0,
          ),
          searched: search.q
            ? data.filter(offer =>
                offer.title.toLowerCase().includes(search.q.toLowerCase()),
              )
            : [],
        })
        setGAEvent(
          'page',
          'loading_duration',
          'offers_catalog',
          Date.now() - pageLoadStart,
        )
      },
      onError: error => {
        setError({
          name: REWARDS_OFFERS_CATALOG,
          error: error.message,
        })

        this.setState({ exclusiveRewardsLoading: false })
      },
    })()
  }

  retrieveInitialData = async () => {
    const { waitRenderServer, renderServer } = this.props

    waitRenderServer(true)

    await this.displayModal()

    renderServer()
  }

  handleOfferActivate = async id => {
    const { accessToken, push, baseUrl } = this.props
    await doActivateOffer({ accessToken, push, baseUrl })(id)
  }

  displayModal = async () => {
    const {
      match,
      setOfferModalData,
      setOfferModalStatus,
      accessToken,
      // advanceAccount,
    } = this.props
    const { viewId } = match.params

    if (viewId) {
      setOfferModalStatus(1)
      try {
        await doGetOffer({ accessToken, setOfferModalData })(viewId)
        setOfferModalStatus(0)
      } catch (e) {
        setOfferModalStatus(4)
      }
    } else {
      setOfferModalData({})
      setOfferModalStatus(null)

      setGAEvent('page', 'page_visit', 'offers_catalog')
    }
  }

  handleClose = () => {
    const { push, baseUrl, setOfferModalData, setOfferModalStatus } = this.props

    if (push) {
      push(`${baseUrl}`)
      setOfferModalData({})
      setOfferModalStatus(null)
    }
  }

  onCatalogChange = catalog => {
    this.setState({
      offers: [],
    })
    this.getRewardsOffers(catalog.id)
  }

  onCatalogSearch = e => {
    const { offers } = this.state

    const searched = offers.filter(offer => {
      const offerTitle = offer.title.toLowerCase()
      const searchQuery = e.target.value.toLowerCase()

      return offerTitle.includes(searchQuery)
    })

    this.setState({
      searchQuery: e.target.value,
      searched,
    })
  }

  render() {
    const {
      showOfferModal,
      offerModalData,
      offerModalStatus,
      advanceAccount,
      accessToken,
      errorList,
      push,
      baseUrl,
      ...theProps
    } = this.props

    const { offers, searched, searchQuery: searchQueryState } = this.state

    const Banner = () => (
      <StyledBanner>
        <BannerContent>
          <BannerDescription>
            <StyledZingLogo />
            <RewardsCatalogTitle>Exclusive Offers</RewardsCatalogTitle>
            <RewardsCatalogDescription>
              Discover premium deals specially for you.
            </RewardsCatalogDescription>
          </BannerDescription>
        </BannerContent>
      </StyledBanner>
    )

    return (
      <CatalogLayout banner={Banner} accessToken={accessToken} {...theProps}>
        <Heading>
          <StyledTextInput
            variant="search"
            whiteOut
            placeholder="What are you looking for?"
            onChange={this.onCatalogSearch}
            onKeyDown={this.onSearchKeyDown}
            value={searchQueryState}
          />
        </Heading>
        <StyledCatalogList
          dataSource={searchQueryState ? searched : offers}
          loadingComponent={() => (
            <StyledCatalogCard
              loading
              error={errorList.find(
                error => error.name === REWARDS_OFFERS_CATALOG,
              )}
              errorMessage="Failed to load Offers."
              onRetry={this.getRewardsOffers}
            />
          )}
          renderItem={(offer, index) => (
            <StyledCatalogCard
              id={index}
              key={offer.id}
              data={offer}
              push={push}
              to={`${baseUrl}/${offer.id}`}
              onClick={() =>
                setGAEvent(
                  'item_clicks',
                  'view_offers_catalog_item',
                  offer.title,
                )
              }
            />
          )}
        />
        <OffersModal
          show={showOfferModal}
          onClose={this.handleClose}
          data={offerModalData}
          advanceAccount={advanceAccount}
          accessToken={accessToken}
          onActivate={this.handleOfferActivate}
          onLinkCard={this.displayAddCardForm}
          loading={offerModalStatus}
        />
        {showOfferModal && offerModalData && (
          <Helmet defaultTitle={offerModalData.title}>
            <meta property="og:title" content={offerModalData.title} />
            <meta
              property="og:description"
              content={filterString(offerModalData.body)}
            />
            <meta property="og:image" content={offerModalData.imageUrl} />
            <meta property="og:type" content="website" />
          </Helmet>
        )}
      </CatalogLayout>
    )
  }
}

MainView.defaultProps = {
  // TODO: specify default props
}

MainView.propTypes = {
  // TODO: specify prop types
}

export default withRouter(MainView)
